import { Board, BoardParticipant } from 'types';

export const getActualPartner = (
  board: Board,
  partnerId: string
): BoardParticipant | undefined =>
  board?.participants.find((p) => p?.member === partnerId);
